import { Link, useLocation } from 'react-router-dom';
import { Home, UtensilsCrossed, ShoppingBag, Receipt, User } from 'lucide-react';
import { useCart } from '../context/CartContext';

export const BottomNav = () => {
  const location = useLocation();
  const { count } = useCart();
  const items = [
    { to: '/', icon: Home, label: 'Home', testId: 'bottom-nav-home' },
    { to: '/menu', icon: UtensilsCrossed, label: 'Menu', testId: 'bottom-nav-menu' },
    { to: '/cart', icon: ShoppingBag, label: 'Cart', testId: 'bottom-nav-cart', badge: count },
    { to: '/orders', icon: Receipt, label: 'Orders', testId: 'bottom-nav-orders' },
    { to: '/profile', icon: User, label: 'Profile', testId: 'bottom-nav-profile' },
  ];
  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-borderbeige shadow-soft">
      <div className="grid grid-cols-5">
        {items.map((it) => {
          const active = location.pathname === it.to;
          const Icon = it.icon;
          return (
            <Link
              key={it.to}
              to={it.to}
              data-testid={it.testId}
              className={`flex flex-col items-center justify-center py-2.5 transition-colors relative ${
                active ? 'text-saffron' : 'text-textsecondary'
              }`}
            >
              <div className="relative">
                <Icon className={`w-5 h-5 ${active ? 'text-saffron' : 'text-textsecondary'}`} />
                {it.badge > 0 && (
                  <span className="absolute -top-1.5 -right-2 bg-saffron text-white text-[10px] font-bold rounded-full min-w-4 h-4 px-1 flex items-center justify-center">
                    {it.badge}
                  </span>
                )}
              </div>
              <span className={`text-[10px] mt-1 font-body ${active ? 'font-semibold' : ''}`}>{it.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
